import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { RequestDetailsFAQView } from "./RequestDetailsFAQView";
import { getTranslatedStudyText } from "./TranslationService";
import { useTranslation } from "react-i18next";
import { RequestDetailsContainer, RequestDetailsTitle, ReasonForRequestSection, ReasonForRequestText, DetailsSection, DetailItem, DetailLabel, DetailValue, FAQsTitle, FAQsContainer, } from "./RequestDetailsView.styles";
export function buildGetCustomizedText(study, language) {
    return (key) => {
        if (!study)
            return "";
        const result = getTranslatedStudyText(study, key, language);
        if (typeof result === "string") {
            return result;
        }
        else if (key === "purposeOfDataDisclosure" && Array.isArray(result)) {
            return result.filter((item) => item !== "Other").join(", ");
        }
        else {
            return "";
        }
    };
}
export const RequestDetailsView = observer((props) => {
    var _a;
    const { t } = useTranslation(["patients"]);
    const { content } = props;
    const study = content.study;
    function disclosureText() {
        const disclosure = content.getCustomizedText("purposeOfDataDisclosure");
        const other = content.getCustomizedText("purposeOfDataDisclosureOther");
        if (disclosure.length > 0 && other.length > 0) {
            return `${disclosure}, ${other}`;
        }
        else if (disclosure.length > 0) {
            return disclosure;
        }
        else if (other.length > 0) {
            return other;
        }
        return "";
    }
    const purposeText = content.isIAS ? null : content.getCustomizedText("purposeOfDataBriefEducation");
    const pageTitle = (_a = props.titleOverride) !== null && _a !== void 0 ? _a : (content.isIAS ? t("Frequently asked questions") : content.isAIFlow ? t("Connector FAQ") : t("Request details"));
    return (_jsxs(RequestDetailsContainer, { children: [!props.hideTitle && _jsx(RequestDetailsTitle, { children: pageTitle }), purposeText && (_jsx(ReasonForRequestSection, { children: _jsx(ReasonForRequestText, { children: content.getCustomizedText("purposeOfDataBriefEducation") }) })), (!content.isAIFlow || props.showDetailsForAIFlow) && (_jsxs(DetailsSection, { children: [study && (_jsxs(DetailItem, { children: [_jsx(DetailLabel, { children: t("Organization") }), _jsx(DetailValue, { children: study.hipaaOrganizationLegalName })] })), _jsxs(DetailItem, { children: [_jsx(DetailLabel, { children: t("Consent duration") }), _jsx(DetailValue, { children: t("1 year") })] }), !content.isIAS && (_jsxs(DetailItem, { children: [_jsx(DetailLabel, { children: t("Request title") }), _jsx(DetailValue, { children: content.getCustomizedText("patientFriendlyTitle") })] })), !content.isIAS && (_jsxs(DetailItem, { children: [_jsx(DetailLabel, { children: t("Purpose of request") }), _jsx(DetailValue, { children: disclosureText() })] }))] })), !content.isIAS && _jsx(FAQsTitle, { children: t("Frequently asked questions") }), _jsx(FAQsContainer, { children: _jsx(RequestDetailsFAQView, { content: content, container: props.container, onViewImage: props.onViewImage }) })] }));
});
